import { SLAStatus } from "../../Enums";
import { ISLAStatusConfig } from "../../Interfaces/ISLAStatusConfig";

export const SLA_CONFIG: Record<SLAStatus, ISLAStatusConfig> = {
  [SLAStatus.NotStarted]: {
    badge: ["sb-gray", "Not Started"],
    bar: [
      "alert-gray",
      "No action required at this stage. Update the status when the SLA process begins.",
    ],
    expiry: "hidden",
    priceReviewDate: "hidden",
    price: "hidden",
    comment: "optional",
    docs: "hidden",
    reminder: false,
    commentsHint: "Optional - add any early notes here.",
    required: [],
    autoCards: false,
  },

  [SLAStatus.InProgress]: {
    badge: ["sb-blue", "In Progress"],
    bar: [
      "alert-blue",
      "SLA is being negotiated. Add comments to track progress. Uploading a document and entering an expiry date will automatically update the status to Current SLA.",
    ],
    expiry: "hidden",
    priceReviewDate: "hidden",
    price: "hidden",
    comment: "required",
    docs: "optional",
    reminder: false,
    commentsHint:
      "Record where negotiations are up to, any agreed terms, or next steps.",
    required: ["comment"],
    autoCards: false,
  },

  [SLAStatus.ClientRefused]: {
    badge: ["sb-red", "Client Refused"],
    bar: [
      "alert-red",
      "Client has declined an SLA. Set a follow-up reminder - this will automatically create an SLA Review action on save.",
    ],
    expiry: "hidden",
    priceReviewDate: "hidden",
    price: "hidden",
    comment: "required",
    docs: "optional",
    reminder: true,
    commentsHint:
      "Record the reason for refusal and context for future reference.",
    required: ["comment", "slaReminderDate", "slaReminderSentTo"],
    autoCards: false,
  },

  [SLAStatus.CurrentSLA]: {
    badge: ["sb-green", "Current SLA"],
    bar: [
      "alert-amber",
      "Current SLA - expiry date, price review date, and a signed document are all required.",
    ],
    expiry: "required",
    priceReviewDate: "required",
    price: "required",
    comment: "optional",
    docs: "required",
    reminder: false,
    commentsHint: "",
    required: ["expiry", "price", "doc", "priceReviewDate"],
    autoCards: true,
  },

  [SLAStatus.SLAExpired]: {
    badge: ["sb-red", "SLA Expired"],
    bar: [
      "alert-amber",
      "SLA has expired. Both dates are locked. Add comments to record next steps.",
    ],
    expiry: "readonly",
    priceReviewDate: "readonly",
    price: "readonly",
    comment: "required",
    docs: "optional",
    reminder: false,
    commentsHint:
      "Document what happens next - renewal, renegotiation, or escalation.",
    required: ["comment"],
    autoCards: false,
  },

  [SLAStatus.SLAExpiredRenewalInProgress]: {
    badge: ["sb-amber", "Renewal in Progress"],
    bar: [
      "alert-amber",
      "Renewal underway. Set the target price review date and keep comments updated.",
    ],
    expiry: "readonly",
    priceReviewDate: "required",
    price: "required",
    comment: "required",
    docs: "optional",
    reminder: false,
    commentsHint:
      "Track renewal progress, outstanding items, and agreed terms.",
    required: ["price", "comment", "priceReviewDate"],
    autoCards: false,
  },

  [SLAStatus.CurrentSLAPendingDocumentUpload]: {
    badge: ["sb-amber", "Current SLA - Pending Document Upload"],
    bar: [
      "alert-amber",
      "Current SLA renegotiation period. Upload a new SLA document to activate.",
    ],
    expiry: "required",
    priceReviewDate: "required",
    price: "required",
    comment: "optional",
    docs: "optional",
    reminder: false,
    commentsHint: "",
    required: ["expiry", "price", "priceReviewDate"],
    autoCards: true,
  },
};
